import * as Yup from 'yup';
import '@dfl/yup-validations';
import { STOCK_OPERATIONS } from '../constants/stock-operations.constants';
import { stockCauseSchema } from 'modules/inventory/common/schemas/common-stock.schema';
import { PRODUCT_STOCK_OPERATIONS } from 'modules/inventory/product/constants/stock-operations.constants';

export const quantityValidation = Yup.number()
  .required('required')
  .when('operation', {
    is: PRODUCT_STOCK_OPERATIONS.ADDED,
    then: (schema) =>
      schema
        .min(0, 'product:warehouseStockModal:error:quantity:min')
        .integer('product:warehouseStockModal:error:quantity:integer'),
    otherwise: (schema) =>
      schema
        .min(1, 'product:warehouseStockModal:error:quantity:min')
        .integer('product:warehouseStockModal:error:quantity:integer'),
  })
  .typeError('product:warehouseStockModal.error.quantity.integer');

const transformSchema = Yup.string()
  .required('required')
  .transform((w) => w?._id || w);

export const commonSchema = Yup.object().shape({
  item: transformSchema,
  operation: Yup.string().oneOf(Object.values(STOCK_OPERATIONS)).required('required'),
  quantity: quantityValidation,
  note: Yup.string(),
  warehouse: transformSchema,
  warehouseArea: Yup.string()
    .transform((w) => w?._id || w)
    .nullable(),
});

// add stock to warehouse
export const stockWarehouseSchema = Yup.object().concat(commonSchema).concat(stockCauseSchema);

// import stock to warehouse
export const stockWarehouseImportStockSchema = Yup.object().shape({
  warehouse: transformSchema,
  file: Yup.mixed().required('required'),
});
